import { RepositoryFactory } from "../../Repository/RepositoryFactory";

const Entitlement = RepositoryFactory.get("entitlement");

/**
 * What this customer has right now (backend#103).
 *
 * Deliberately NOT gated on anything in the cached user. The bug this replaces
 * was exactly that: Setting.js asked whether the browser's copy of the user
 * had a stripe_customer_id and, when it didn't, never made the request at all
 * — so 778 customers were told they had nothing, and a brand-new paying
 * customer saw the free plan because their cached copy predated the payment.
 *
 * The server answers from its own records. Ask it.
 *
 * Swallows its own errors and hands back null: a Settings page that cannot
 * reach this endpoint should render a plain "we couldn't load your plan"
 * rather than a spinner that never ends. Note that a Stripe failure is NOT
 * this case — the server still answers 200, with `billing.known: false`.
 */
export const getEntitlement =
  (onSuccess = () => {}) =>
  async () => {
    try {
      const { data } = await Entitlement.getEntitlement();
      onSuccess(data?.data || null);
    } catch (error) {
      console.error("entitlement:", error.message);
      onSuccess(null);
    }
  };
